enum UserRoles {
  USER = 0,
  SECURITY = 1,
  MANAGER = 2,
  ADMIN = 3,
}

export default UserRoles;
